import styled from 'styled-components';

const Button = styled.button`
  margin: 10px;
  background-color: ${props => (props.disabled ? 'grey' : 'green')};
  padding: 10px;
  color: white;
  font-weight: bold;
`;

export default Button;
